var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRobot2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1872_127",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#F8153B"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1872_127)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33325 17.5V13.3333C3.33325 12.875 3.49645 12.4826 3.82284 12.1562C4.14922 11.8299 4.54159 11.6667 4.99992 11.6667H14.9999C15.4583 11.6667 15.8506 11.8299 16.177 12.1562C16.5034 12.4826 16.6666 12.875 16.6666 13.3333V17.5H3.33325ZM7.49992 10.8333C6.34714 10.8333 5.3645 10.4271 4.552 9.61458C3.7395 8.80208 3.33325 7.81944 3.33325 6.66667C3.33325 5.51389 3.7395 4.53125 4.552 3.71875C5.3645 2.90625 6.34714 2.5 7.49992 2.5H12.4999C13.6527 2.5 14.6353 2.90625 15.4478 3.71875C16.2603 4.53125 16.6666 5.51389 16.6666 6.66667C16.6666 7.81944 16.2603 8.80208 15.4478 9.61458C14.6353 10.4271 13.6527 10.8333 12.4999 10.8333H7.49992ZM7.49992 7.5C7.73603 7.5 7.93395 7.42014 8.09367 7.26042C8.25339 7.10069 8.33325 6.90278 8.33325 6.66667C8.33325 6.43056 8.25339 6.23264 8.09367 6.07292C7.93395 5.91319 7.73603 5.83333 7.49992 5.83333C7.26381 5.83333 7.06589 5.91319 6.90617 6.07292C6.74645 6.23264 6.66659 6.43056 6.66659 6.66667C6.66659 6.90278 6.74645 7.10069 6.90617 7.26042C7.06589 7.42014 7.26381 7.5 7.49992 7.5ZM12.4999 7.5C12.736 7.5 12.9339 7.42014 13.0937 7.26042C13.2534 7.10069 13.3333 6.90278 13.3333 6.66667C13.3333 6.43056 13.2534 6.23264 13.0937 6.07292C12.9339 5.91319 12.736 5.83333 12.4999 5.83333C12.2638 5.83333 12.0659 5.91319 11.9062 6.07292C11.7464 6.23264 11.6666 6.43056 11.6666 6.66667C11.6666 6.90278 11.7464 7.10069 11.9062 7.26042C12.0659 7.42014 12.2638 7.5 12.4999 7.5Z",
    fill: "#F8153B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobot2);
export default __webpack_public_path__ + "static/media/Robot_2.b3ed072c013dafd5a5a1b44442ab9b2a.svg";
export { ForwardRef as ReactComponent };